var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tableau-embed-container"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"21by9","src":_vm.url,"width":_vm.width,"height":_vm.height}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }